// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-calendar {
    display: block;
}

.well {
    border: solid 1px #d3d3d3;
    background-color: #f5f5f5;
    padding: 15px 20px;
    border-radius: 4px;
    margin-bottom: 15px;
}

.control-label, label {
    display: block;
    margin-bottom: 4px;
    margin-top: 10px;
}

.form-group > .control-label:first-child,
.form-group > label:first-child {
    margin-top: 0;
}

.btn-toolbar {
    margin-top: 15px;
    padding: 5px 0;
    gap: 8px;
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/app/reports/bank-and-surety-listing/bank-and-surety-listing.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,QAAQ;IACR,aAAa;AACjB","sourcesContent":[".block-calendar {\r\n    display: block;\r\n}\r\n\r\n.well {\r\n    border: solid 1px #d3d3d3;\r\n    background-color: #f5f5f5;\r\n    padding: 15px 20px;\r\n    border-radius: 4px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.control-label, label {\r\n    display: block;\r\n    margin-bottom: 4px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.form-group > .control-label:first-child,\r\n.form-group > label:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n.btn-toolbar {\r\n    margin-top: 15px;\r\n    padding: 5px 0;\r\n    gap: 8px;\r\n    display: flex;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
